import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const checkboxWrapper = css`
  margin: 0;
`;

export const checkboxWrapperContainer = css`
  display: flex;
  padding-bottom: ${spacing.sm}px;
`;

export const secondaryLabel = css`
  flex-grow: 1;
  align-self: center;
  text-align: right;
  ${responsiveText.BODY.SM};
  color: var(--neutral-black-40);
  font-weight: 400;
  margin-top: ${spacing.base}px;
`;
